module.exports = __webpack_public_path__ + "static/media/RWRB.b0725ac2.png";